<template>
    <div class="base-wrapper">
        <!-- 引流弹窗 -->
        <div class="activity-download-pop" v-if="baseData.isApp == 1 && !isApp">
            <div class="activity-download-pop-inner">
                <p>参加该活动需在封面新闻APP中进行</p>
                <span @click="downLoadApp" data-trackevent="click" data-tracklabel="下载" data-track="track">确认</span>
            </div>            
        </div>
        <!-- 活动结束 -->
        <div class="activity-end" v-if="baseData.status == 2">
            <img src="https://wapcdn.thecover.cn/activity/public/activity_end_1.0.0.png" alt="">
        </div> 
    </div>
</template>

<script>

import CONFIG from '@/utils/config'
import WX from 'wechat-js-sdk'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'

import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            id: '',
            hasMusic: false,
            musicFlag: true,
            audioDom: null
        }
    },
    props: ['baseData'],
    computed: {
        ...mapState(['isApp'])
    },
    created() {
        let baseData = this.baseData
    },
    mounted() {        
        COVER.isWapHidden()
        this.share()
        this.appFlagAsync(COVERAPP.Attribute.isApp())
    },
    methods: {
        ...mapActions([
            'appFlagAsync'
        ]),
        //分享
        share() {
            let data = this.baseData
            let shareData = {
                title: data.title,
                desc: data.title,
                imgUrl: 'https://wapcdn.thecover.cn/wap/2.3.4/share_logo.png',
                link: window.location.href
            }
            COVER.share(shareData)
        },
        //下载APP
        downLoadApp() {
            COVER.$getScript(CONFIG.DOWNLOAD_ADDRESS).then(()=> {
                COVER.downloadApp(this.baseData._id)
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .activity-download-pop {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
        z-index: 9;
        .activity-download-pop-inner {
            position: absolute;
            transform: translate(-50%, -50%);
            left: 50%;
            top: 50%;
            width: 6.5rem;
            padding: 0.5rem;
            background-color: #fff;
            border-radius: .2rem;
            box-sizing: border-box;
            font-size: .45rem;
            text-align: center;
            p {
                color: #474747;
                line-height: 1.3;
            }
            span {
                display: inline-block;
                min-width: 3.3rem;
                text-align: center;
                color: #fff;
                line-height: 1rem;
                padding: 0 .3rem;
                background-color: #e62f17;
                margin: .3rem 0 .1rem;
                border-radius: .2rem;
                letter-spacing: .1rem;
                box-sizing: border-box;
                cursor: pointer;
            }
        }
    }

    .activity-end {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,0.7);
        z-index: 10;
        img {
            position: absolute;
            bottom: 0;
        }
    }
</style>
